var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIkZalezne = function SvgIkZalezne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.434,
    height: 15.053
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6370"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6788",
    fill: "none",
    stroke: "#156BB7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3424",
    d: "M.996 5.499v3.439a1.972 1.972 0 0 0 2.151 1.72h8.684a1.972 1.972 0 0 0 2.152-1.72V7.299"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3447",
    d: "M.996 6.688V2.736a2.017 2.017 0 0 1 2.218-1.72h8.952c1.225 0-.594.006 0 0h0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8734"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6370"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6788",
    fill: "none",
    stroke: "#156BB7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3424",
    d: "M22.434 9.554V6.115a1.972 1.972 0 0 0-2.152-1.72h-8.684a1.972 1.972 0 0 0-2.151 1.72v1.64"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3447",
    d: "M22.434 8.365v3.952a2.017 2.017 0 0 1-2.218 1.72h-8.952c-1.225 0 .594-.006 0 0h0"
  })))))));
};
export default SvgIkZalezne;